export default "__VITE_ASSET__ZiTjh6FR__"